import ControllerLoader from './ControllerLoader';
import { N2Handle, N2Ready } from './N2';

N2Ready(() => {
  N2Handle('click', '.js-history-back', () => {
    window.history.back();
  });
});

window.onpopstate = (e) => {
  ControllerLoader.unload(e);
};

// Cleanup the page before making a turbolinks cache image.
$(document).on('turbolinks:before-cache', () => {
  // Remove partially-hidden user settings dropdowns.
  $('#sidenav-overlay').remove();
});
